import React, { memo, PropsWithChildren, ReactNode } from 'react'
import styled from 'styled-components'
import Modal from 'react-modal'
import cx from 'classnames'
import { useDispatch } from 'react-redux'

import { modalsActions } from '../../../store/modals/modalsSlice'
import { ModalContent, ModalFooter, ModalHeader, modalStyle as defaultModalStyle } from '../styles'
import { ChasingDotsLoader } from '../../design-system/ChasingDotsLoader'

type Props = PropsWithChildren<{
  title?: string | ReactNode
  footer: ReactNode
  open?: boolean
  modalStyle?: ReactModal.Styles
  modalContentStyle?: React.CSSProperties
  className?: string
  onClose?: (resolveValue?: any) => void
  loading?: boolean
}>

export const CustomPopup: React.FC<Props> = memo<Props>(
  ({
    title,
    children,
    loading,
    footer,
    onClose,
    open = true,
    modalStyle = {},
    modalContentStyle = {},
    className
  }) => {
    const dispatch = useDispatch()
    const onCloseRedux = () => dispatch(modalsActions.closeModal())

    return (
      <Modal
        isOpen={open}
        className={cx('modal-default', className)}
        style={{
          ...defaultModalStyle,
          content: { ...defaultModalStyle.content, ...modalStyle.content }
        }}
        onRequestClose={() => {
          onClose?.() || onCloseRedux()
        }}
      >
        {title && (
          <ModalHeader>
            <Title>{title}</Title>
          </ModalHeader>
        )}
        <ModalContent style={modalContentStyle} withoutTopBorder={!title}>
          {loading ? <ChasingDotsLoader /> : children}
        </ModalContent>
        <ModalFooter>{footer}</ModalFooter>
      </Modal>
    )
  }
)

export type CustomPopupProps = Props

const Title = styled.label.attrs({ className: 'modal-title' })`
  align-self: center;
  font-size: 18px;
  font-weight: 500;
  text-align: left;
`
